$(document).ready(function(){
 $(document).ready(function() {
    // Smooth scroll animation for anchor links
    $('a[href^="#"]').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if (target.length) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 1000); // Adjust the animation duration as needed
        }
    });
});
});

// Subscribe landing page slider

$('.image-block-slider').slick({
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false
      }
    }
  ]
});

// Subscribe toggle button
$(".btn-subscribe").click(function() {
  if ($(this).hasClass("btn-active")) {
      $(this).removeClass("btn-active");
      $(this).text("Subscribe");
      $(".subscription-collection").removeClass("active");
    } else {
      $(".btn-subscribe.btn-active").removeClass("btn-active").text("Subscribe");
      $(this).addClass("btn-active").text("CLOSE");
      $(".subscription-collection").removeClass("active");
      $(this).next(".subscription-collection").addClass("active");
    }
});

// Footer Menu
$(document).ready(function() {
  $('.footer-block__heading').click(function() {
    // Remove 'active' class from all other footer blocks
    $('.footer-block--menu').not($(this).parent()).find('.footer-block__details-content').removeClass('active');
    $('.footer-block--menu').not($(this).parent()).find('.footer-block__heading').removeClass('active');

    // Toggle 'active' class on clicked footer block
    $(this).toggleClass('active');
    $(this).parent().find('.footer-block__details-content').toggleClass('active');
  });
});

// menu remove open attribute



// $("#Details-menu-drawer-container").click(function(){
//     if ($(this).hasClass("menu-opening")) {
//     } else {
//         $(this).removeAttr("open")
//     }
// });

// $("#Details-menu-drawer-container").click(function() {
//   $("body").toggleClass("menu-open");
//   $(".overlay-mobile-menu").toggleClass("menu-open");
// });

// Subscription page video
const videoWrappers = document.querySelectorAll('.video-wrapper');

videoWrappers.forEach(function(videoWrapper) {
  const thumbBtn = videoWrapper.querySelector('.video-play-btn');
  const videoThumb = videoWrapper.querySelector('.video-thumbnail');
  const videoIframe = videoWrapper.querySelector('iframe');

  thumbBtn.addEventListener('click', function() {
    videoThumb.style.display = 'none';
    thumbBtn.style.display = 'none';
    videoIframe.src += '?autoplay=1';
  });
});

const dynamicProductPrice = document.querySelector('.rc-option__price');

// Progress bar cartAjax
$('.progress[data-progress]').filter(function() {
  return $(this).attr('data-progress') >= 5;
}).css('width', '100%');

// Apply discount code using Ajax
$('#apply-discount').click(function() {
  var discountCode = $('#cart-discount-code').val();
  if (discountCode.length) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        discount: discountCode
      },
      success: function() {
        location.reload();
      },
      error: function() {
        alert('Invalid discount code');
      }
    });
  }
});


// Blog Search

let searchInput = document.querySelector('.Search__Input');
let searchButton = document.querySelector('.Search__Button');

searchInput.addEventListener('input', updateSearchButton);
searchInput.addEventListener('focus', updateSearchButton);


function updateSearchButton() {
  if (searchInput.value.trim() !== '' || searchInput === document.activeElement) {
    searchButton.innerHTML = ''; // Remove the image from the button
  } else {
    searchButton.innerHTML = '<img src="//cdn.shopify.com/s/files/1/0635/5612/4930/t/9/assets/search.png?v=149754963049688574681684393151">';
  }
}